import { Droppable } from 'react-beautiful-dnd'

import ReleaseBlock from './ReleaseBlock'
import ReleasesEmptyState from './ReleasesEmptyState'
import styles from '../../ProjectStoryMapBoard.module.css'

const ReleasesPane = ({
    releases,
    gridTemplateColumns,
    boardTracks,
    draggingStoryReleaseId,
    storyDragOverCellKey = null,
    isStoryDragging = false,
    onSyncHorizontalScroll,
    onAddRelease,
    onAddStory,
    onToggleReleaseCollapse,
    onOpenStory,
    editingStoryId,
    editingStoryDraft,
    storyInputRef,
    onStoryDraftChange,
    onCommitStoryTitle,
    onOpenRelease,
    releaseMenu,
    storyMenu,
    highlightedCardId,
    isFilterActive = false,
    filterFocusedCardId = null,
    readOnly = false,
}) => (
    <Droppable droppableId="releases" type="RELEASE">
        {(releaseDrop) => (
            <div
                ref={releaseDrop.innerRef}
                {...releaseDrop.droppableProps}
                className={`${styles.releaseStack} ${
                    releases.length === 0 ? styles.releaseStackEmpty : ''
                }`}
            >
                {releases.length === 0 ? (
                    <ReleasesEmptyState onAddRelease={onAddRelease} readOnly={readOnly} />
                ) : (
                    releases.map((release, releaseIndex) => (
                        <ReleaseBlock
                            key={release.id}
                            release={release}
                            releaseIndex={releaseIndex}
                            gridTemplateColumns={gridTemplateColumns}
                            boardTracks={boardTracks}
                            draggingStoryReleaseId={draggingStoryReleaseId}
                            storyDragOverCellKey={storyDragOverCellKey}
                            isStoryDragging={isStoryDragging}
                            onSyncHorizontalScroll={onSyncHorizontalScroll}
                            onAddRelease={onAddRelease}
                            onAddStory={onAddStory}
                            onToggleCollapse={onToggleReleaseCollapse}
                            onOpenStory={onOpenStory}
                            editingStoryId={editingStoryId}
                            editingStoryDraft={editingStoryDraft}
                            storyInputRef={storyInputRef}
                            onStoryDraftChange={onStoryDraftChange}
                            onCommitStoryTitle={onCommitStoryTitle}
                            onOpenRelease={onOpenRelease}
                            releaseMenu={releaseMenu}
                            storyMenu={storyMenu}
                            highlightedCardId={highlightedCardId}
                            isFilterActive={isFilterActive}
                            filterFocusedCardId={filterFocusedCardId}
                            readOnly={readOnly}
                        />
                    ))
                )}
                {releaseDrop.placeholder}
            </div>
        )}
    </Droppable>
)

export default ReleasesPane
